import React, { Component } from "react";
import styled from "styled-components";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import theme from "ui/styles/theme";
import Results from "./Results";
import LocalizedString from "ui/components/generic/LocalizedString";
import Button from "ui/components/generic/Button";
import withQuery from "containers/withQuery";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { compose } from "react-apollo";
import { withRouter } from "react-router";
import withTranslations from "containers/withTranslations";

class index extends Component {
  state = {
    product: "",
    documentType: "",
    language: "",
    search: "",
    filterActive: false,
    sortedProducts: [],
    isVisible: false,
    visibleText: "",
    allDocuments: [],
  };

  async componentDidMount() {
    //Fetch all documents and save to state
    await this.fetchAllDocuments();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            this.setState({ isVisible: true });
          } else {
            this.setState({ isVisible: false });
          }
        });
      },
      { threshold: [0, 0.1, 0.3, 0.5, 0.7, 1] }
    );
    observer.observe(document.querySelector(".resultso"));
    //Sorting products and remove the ones without any documents
    if (this.state.allDocuments) {
      this.productsSort(this.props.products, this.state.allDocuments);
    }
  }

  fetchAllDocuments = async () => {
    let hasNextPage = true;
    let endCursor = null;
    let allDocs = [];

    while (hasNextPage) {
      const result = await this.props.client.query({
        query: gql`
          query GetDocuments($after: String) {
            documents(first: 999, after: $after) {
              pageInfo {
                hasNextPage
                endCursor
              }
              nodes {
                product
              }
            }
          }
        `,
        variables: { after: endCursor },
      });

      const { nodes, pageInfo } = result.data.documents;
      allDocs = [...allDocs, ...nodes];
      hasNextPage = pageInfo.hasNextPage;
      endCursor = pageInfo.endCursor;
    }

    this.setState({ allDocuments: allDocs });
  };

  productsSort = (prd, docs) => {
    console.log(docs);
    //Get slugs from an array of objects
    let prdArray = prd.map((x) => x.slug);
    //Get all the documents with assigned at least one product
    let filteredDocs = docs.map((d) => d.product);
    //Remove products that don't have a document
    filteredDocs = filteredDocs.filter((x) => prdArray.includes(x));
    //Remove repeating products
    filteredDocs = [...new Set(filteredDocs)];
    //Remove proudcts from an original array
    const prod = prd.filter((s) => filteredDocs.includes(s.slug));

    let sortedPrd = prod.sort((a, b) =>
      a.title
        .replace(/^i/, "")
        .localeCompare(b.title.replace(/^i/, ""), undefined, {
          numeric: true,
          sensitivity: "base",
        })
    );
    if (this.state.sortedProducts.length === 0) {
      this.setState({ sortedProducts: sortedPrd });
    } else {
    }
  };

  gotoResults = () => {
    document
      .querySelector(".containerOptions")
      .scrollIntoView({ behavior: "smooth", block: "center" });
  };

  ScrollToTarget = () => {
    let isMobile = window.matchMedia(
      "only screen and (max-width: 480px)"
    ).matches;
    let target = document.querySelector(".containerOptions");
    let scrollOffset = isMobile ? 300 : 100;
    let elementPosition = target.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset + scrollOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  resultsVisibility = () => {
    if (this.state.isVisible === false) {
      document
        .querySelector(".containerOptions")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  updateFilters(change) {
    this.setState((state) => ({
      ...state,
      ...change,
      filterActive: true,
    }));
  }

  resetFilters() {
    this.setState({
      product: "",
      documentType: "",
      language: "",
      search: "",
      filterActive: false,
    });
  }

  render() {
    const {
      heading,
      products,
      documentTypes,
      languages,
      showAllDocuments,
      translations,
      documents,
    } = this.props;

    const { product, documentType, language, search, filterActive } =
      this.state;
    return (
      <Wrapper fluid>
        <InsideWrapper>
          <Row>
            <Col lg={12}>
              <Heading>{heading}</Heading>
              <Inner>
                <Row className="containerOptions">
                  <Col md={6}>
                    <Field>
                      <Label>
                        <LocalizedString
                          group="documentLabels"
                          string="product"
                        />
                      </Label>
                      <Select
                        onChange={(e) =>
                          this.updateFilters({ product: e.target.value || "" })
                        }
                        value={product}
                        onClick={this.resultsVisibility}
                      >
                        <option value="">
                          {translations
                            ? translations.documentPlaceholders.product
                            : "Select product"}
                        </option>
                        {this.state.sortedProducts.map((p) => (
                          <option value={p.slug} key={p.slug}>
                            {p.title}
                          </option>
                        ))}
                      </Select>
                    </Field>
                    <Field>
                      <Label>
                        <LocalizedString
                          group="documentLabels"
                          string="documentType"
                        />
                      </Label>
                      <Select
                        onChange={(e) =>
                          this.updateFilters({
                            documentType: e.target.value || "",
                          })
                        }
                        value={documentType}
                      >
                        <option value="">
                          {translations
                            ? translations.documentPlaceholders.documentType
                            : "Select documentType"}
                        </option>
                        {documentTypes.map((d) => (
                          <option value={d.slug} key={d.slug}>
                            {d.title}
                          </option>
                        ))}
                      </Select>
                    </Field>
                  </Col>
                  <Col md={6}>
                    <Field>
                      <Label>
                        <LocalizedString
                          group="documentLabels"
                          string="language"
                        />
                      </Label>
                      <Select
                        onChange={(e) =>
                          this.updateFilters({ language: e.target.value || "" })
                        }
                        value={language}
                      >
                        <option value="">
                          {translations
                            ? translations.documentPlaceholders.language
                            : "Select language"}
                        </option>
                        {languages.map((l) => (
                          <option value={l.slug} key={l.slug}>
                            {l.title}
                          </option>
                        ))}
                      </Select>
                    </Field>
                    <Field>
                      <Label>
                        <LocalizedString
                          group="documentLabels"
                          string="freeTextSearch"
                        />
                      </Label>
                      <Input
                        type="text"
                        onChange={(e) =>
                          this.updateFilters({ search: e.target.value })
                        }
                        value={search}
                      />
                    </Field>
                  </Col>
                </Row>
                <Row className="resultso">
                  <ExpandedCol>
                    <Reset>
                      <Button
                        to="#"
                        hollow="true"
                        onClick={() => this.resetFilters()}
                      >
                        <LocalizedString
                          group="documentLabels"
                          string="reset"
                        />
                      </Button>
                    </Reset>
                    <Search>
                      <ExpandedButton
                        to="#"
                        onClick={() => this.ScrollToTarget()}
                        hollow="false"
                      >
                        <LocalizedString
                          group="documentLabels"
                          string="search"
                        />
                      </ExpandedButton>
                    </Search>
                  </ExpandedCol>
                </Row>
              </Inner>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Results
                product={product}
                documentType={documentType}
                language={language}
                search={search}
                documentTypes={documentTypes}
                languages={languages}
                products={products}
                showAllDocuments={showAllDocuments}
                filterActive={filterActive}
              />
            </Col>
          </Row>
        </InsideWrapper>
      </Wrapper>
    );
  }
}

export default compose(withRouter, withApollo, withTranslations())(index);

// Styles
const Field = styled.div`
  margin-bottom: 40px;
`;

const Inner = styled.div`
  padding: 30px 50px;
  background-color: ${(props) => props.theme.colors.primary};
  color: #fff;
`;

const Wrapper = styled(Container)`
  background-color: ${(props) => props.theme.colors.tones.lightest};
  ${media.lg`
padding: 30px 20% 50px 20%;
`}
`;

const InsideWrapper = styled.div`
  width: 100%;
`;

const Heading = styled.h2`
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 40px;
`;

const Label = styled.label`
  font-size: 12px;
  text-transform: uppercase;
`;

const ExpandedCol = styled(Col)`
  display: flex;
  justify-content: space-evenly;

  ${media.md`
    justify-content: end;
  `}
`;

const ExpandedButton = styled(Button)`
  background-color: #00964b !important;
  color: white !important;
  transition: all 400ms;
  border: none !important;
  &:hover {
    background-color: #00994cad !important;
  }
`;

const Select = styled.select`
  background: none;
  width: 100%;
  border: none;
  border-bottom: 1px solid white;
  appearance: none;
  border-radius: 0;
  color: ${theme.colors.secondary};
  padding: 20px 10px;
  outline: none;
`;

const Input = styled.input`
  background: none;
  border: none;
  border-bottom: 1px solid white;
  padding: 20px 10px;
  width: 100%;
  outline: none;
  color: ${theme.colors.secondary};
`;

const Reset = styled.div`
  text-align: right;
`;
const Search = styled.div`
  text-align: right;
  margin-left: 10px;

  ${media.md`
  margin-left: 20px;
  `}
`;



// WEBPACK FOOTER //
// ./src/ui/components/modules/DocumentSearch/index.js